import { call, put, all, fork, takeEvery } from 'redux-saga/effects'

import { showLoading, hideLoading } from 'react-redux-loading-bar'

import MosqueRequestsService from '../middlewares/mosqueRequests'

import {
  GET_MOSQUE_REQUESTS,
  GET_MOSQUE_REQUESTS_REQUEST,
  GET_MOSQUE_REQUESTS_REQUEST_ERROR,
  GET_MOSQUE_REQUESTS_REQUEST_PENDING,
  GET_MOSQUE_REQUESTS_REQUEST_SUCCESS,
  GET_MOSQUE_REQUEST_BY_ID,
  GET_MOSQUE_REQUEST_BY_ID_REQUEST,
  UPDATE_MOSQUE_REQUEST_STATUS_REQUEST,
  UPDATE_MOSQUE_REQUEST_STATUS,
  UPDATE_MOSQUE_REQUEST_STATUS_PENDING,
  UPDATE_MOSQUE_REQUEST_STATUS_SUCCESS,
  UPDATE_MOSQUE_REQUEST_STATUS_ERROR,
} from '../types/mosqueRequests'

function* getMosqueRequestsWatcher() {
  yield takeEvery(GET_MOSQUE_REQUESTS_REQUEST, getMosqueRequestsWorker)
}

function* getMosqueRequestByIdWatcher() {
  yield takeEvery(GET_MOSQUE_REQUEST_BY_ID_REQUEST, getMosqueRequestByIdWorker)
}

function* updateMosqueRequestStatusWatcher() {
  yield takeEvery(UPDATE_MOSQUE_REQUEST_STATUS_REQUEST, updateMosqueRequestStatusWorker)
}

function* getMosqueRequestsWorker({ payload: { page, size, search, status } }) {
  try {
    yield put(showLoading())
    yield put({ type: GET_MOSQUE_REQUESTS_REQUEST_PENDING })
    const response = yield call(MosqueRequestsService.getMosqueRequests, page, size, search, status)
    const { data, total } = response?.data?.data || {}
    yield put({
      type: GET_MOSQUE_REQUESTS,
      payload: {
        items: data,
        pagination: {
          current: page,
          pageSize: size,
          total: total,
        },
      },
    })
    yield put({ type: GET_MOSQUE_REQUESTS_REQUEST_SUCCESS })
    yield put(hideLoading())
  } catch (error) {
    yield put({ type: GET_MOSQUE_REQUESTS_REQUEST_ERROR, payload: error.response?.data?.messages || [] })
    yield put(hideLoading())
  }
}

function* getMosqueRequestByIdWorker({ payload: id }) {
  try {
    yield put(showLoading())
    const response = yield call(MosqueRequestsService.getMosqueRequestById, id)
    yield put({
      type: GET_MOSQUE_REQUEST_BY_ID,
      payload: response.data,
    })
    yield put(hideLoading())
  } catch (error) {
    yield put({ type: GET_MOSQUE_REQUESTS_REQUEST_ERROR, payload: error.response?.data?.messages || [] })
    yield put(hideLoading())
  }
}

function* updateMosqueRequestStatusWorker({ payload: { id, status, onSuccess, onError } }) {
  try {
    yield put(showLoading())
    yield put({ type: UPDATE_MOSQUE_REQUEST_STATUS_PENDING })
    const response = yield call(MosqueRequestsService.updateMosqueRequestStatus, id, status)
    yield put({
      type: UPDATE_MOSQUE_REQUEST_STATUS,
      payload: response.data?.data || response.data,
    })
    yield put({ type: UPDATE_MOSQUE_REQUEST_STATUS_SUCCESS })
    yield put(hideLoading())
    if (onSuccess) onSuccess()
  } catch (error) {
    yield put({ type: UPDATE_MOSQUE_REQUEST_STATUS_ERROR, payload: error.response?.data?.messages || [] })
    yield put(hideLoading())
    if (onError) onError()
    else if (onSuccess) onSuccess() // Reset loading state on error
  }
}

export default function* mosqueRequests() {
  yield all([fork(getMosqueRequestsWatcher), fork(getMosqueRequestByIdWatcher), fork(updateMosqueRequestStatusWatcher)])
}

